import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ForceChangePasswordGuard implements CanActivate {
  constructor(
    private _localStorageService: LocalStorageService,
    private _router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const forcePasswordChange = this._localStorageService.getValueByKey('forcePasswordChange');
    if (forcePasswordChange === 'true') {
      this._router.navigate(['/account/change-password']);
      return false;
    }
    return true;
  }
}
